import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    alert('Message sent successfully!');
    setName('');
    setEmail('');
    setMessage('');
  };

  return (
    <div className="contact-us-page">
      <div className="contact-container">
        <div className="contact-info">
          <h1>Contact Us</h1>
          <p>We would love to hear from you! Please fill out the form below or contact us via phone or email, and we will get back to you as soon as possible.</p>
          
          <h3>Our Location</h3>
          <p>OJ Mechanisms</p>
             <p>Nairobi, Kenya</p>
             <p>Lang'ata, Nairobi</p>


          <h3>Phone</h3>
          <p><a href="tel:+254792454764">+254792454764</a></p>

          <h3>Email</h3>
          <p><a href="mailto:info@ojmechanisms.com">info@ojmechanisms.com</a></p>

          <h3>Opening Hours</h3>
          <p>Monday to Friday: 9 AM - 6 PM<br />
             Saturday: 10 AM - 4 PM<br />
             Sunday: Closed</p>
        </div>

        <div className="contact-form">
          <h2>Send Us a Message</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">Name:</label>
              <input
                type="text"
                id="name"
                value={name}
                onChange={(e) => setName(e.target.value)}
                placeholder="Enter your name"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="email">Email:</label>
              <input
                type="email"
                id="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter your email"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="message">Message:</label>
              <textarea
                id="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Your message here..."
                required
              />
            </div>

            <button type="submit" className="submit-btn">Send Message</button>
          </form>
        </div>
      </div>

      {/* Enlarged Map Section */}
      <div className="map-section">
        <h2>Find Us in Nairobi</h2>
        <div className="map-container">
          <iframe
            title="Nairobi Map"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15955.072546213597!2d36.8219460984375!3d-1.2920656206950524!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x182f10d4f1f100d7%3A0xc4c86b03a15880b5!2sNairobi%2C%20Kenya!5e0!3m2!1sen!2s!4v1696598147806!5m2!1sen!2s"
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
      </div>
    </div>
  );
};

export default Contact;
